export default {
  methods: {
    setCartForDengage() {
      const cartItems = JSON.parse(localStorage.getItem("basket") || '[]').map(cartItem => {
        const price = Number(cartItem.oldPrice || cartItem.price);
        const discountedPrice = Number(cartItem.price);

        const productId = String(cartItem.id);

        return {
          product_id: productId,
          product_variant_id: productId,
          quantity: parseInt(cartItem.quantity),
          price: Math.max(price, discountedPrice),
          discounted_price: discountedPrice,
          category_path: cartItem.category + ' > ' + cartItem.brand,
          has_discount: discountedPrice < price,
          has_promotion: (discountedPrice / price) <= 0.75,
          attributes: {
            name: cartItem.name,
            desc: cartItem.desc,
            brand: cartItem.brand,
            colors: cartItem.colors.join(',')
          }
        }
      });

      dengage('setCart', cartItems, (result) => {
        console.log('setCart result', result)
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/setCart.js